
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2h12v20H12V2z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4 3v1h4V2H4v1zm5 1H8v4h2V4H9zM8 9V8H4v2h4V9zM3 8h1V4H2v4h1zm1 1V8H2a2 2 0 002 2V9zm5-1H8v2a2 2 0 002-2H9zM8 3v1h2a2 2 0 00-2-2v1zM4 3V2a2 2 0 00-2 2h2V3zM16 9v1h4V8h-4v1zm5 1h-1v4h2v-4h-1zm-1 5v-1h-4v2h4v-1zm-5-1h1v-4h-2v4h1zm1 1v-1h-2a2 2 0 002 2v-1zm5-1h-1v2a2 2 0 002-2h-1zm-1-5v1h2a2 2 0 00-2-2v1zm-4 0V8a2 2 0 00-2 2h2V9zM4 15v1h4v-2H4v1zm5 1H8v4h2v-4H9zm-1 5v-1H4v2h4v-1zm-5-1h1v-4H2v4h1zm1 1v-1H2a2 2 0 002 2v-1zm5-1H8v2a2 2 0 002-2H9zm-1-5v1h2a2 2 0 00-2-2v1zm-4 0v-1a2 2 0 00-2 2h2v-1z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M9 6h1a2 2 0 012 2v2a2 2 0 002 2h1","stroke":"#4A4A4A","stroke-width":"2"}})])
          )
        }
      }
    